import { RootState } from "app/store";
import { PopupTarget } from "./state";
import { DownloadProduct, InitializeState, ExcuteState } from "./types";

// ダウンロード一覧を取得する
export const selectDownloadList = (state: RootState): DownloadProduct[] => {
  const products = state.download.domains.Products;

  if (!products) {
    return [];
  }
  if (products.products.length === 0) {
    return [];
  }
  return products.products.map(
    (x): DownloadProduct => ({
      id: x.id,
      name: x.name,
      version: x.version,
      libVer: x.libVer,
      releaseDate: x.releaseDate,
      fid: x.fid,
      downloadId: x.downloadId,
      groupId: x.groupId,
      groupName: x.groupName,
      groupOrder: x.groupOrder
    }),
  );
};

export const selectInitializeState = (state: RootState): InitializeState =>
  state.download.apps.initialize;

export const selectPopupTarget = (state: RootState): PopupTarget | undefined =>
  state.download.apps.popupTarget;

export const selectExcuteState = (state: RootState): ExcuteState | undefined =>
  state.download.apps.excuteState;
  
